import React, { useEffect, useState } from "react";
import MetaData from "../layout/MetaData";
import CheckoutSteps from "./CheckoutSteps";
import { useSelector } from "react-redux";
import { calculateOrderCost } from "../../helpers/Helpers";
import { useCreateNewOrderMutation } from "../../redux/api/orderApi";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const PaymentMethod = () => {
    const [method, setMethod] = useState("");
    const [jazzcashScreenshot, setJazzcashScreenshot] = useState(""); // base64
    const [jazzcashFileName, setJazzcashFileName] = useState("");

    const navigate = useNavigate();

    const { shippingInfo, cartItems } = useSelector((state) => state.cart);
    const [createNewOrder, { isLoading, error, isSuccess }] =
        useCreateNewOrderMutation();

    useEffect(() => {
        if (error) {
            toast.error(error?.data?.message);
        }

        if (isSuccess) {
            navigate("/me/orders?order_success=true");
        }
    }, [error, isSuccess, navigate]);

    const submitHandler = (e) => {
        e.preventDefault();

        const { itemsPrice, shippingPrice, taxPrice, totalPrice } =
            calculateOrderCost(cartItems);

        if (method === "COD") {
            const orderData = {
                shippingInfo,
                orderItems: cartItems,
                itemsPrice,
                shippingAmount: shippingPrice,
                taxAmount: taxPrice,
                totalAmount: totalPrice,
                paymentInfo: {
                    status: "not_paid",
                },
                paymentMethod: "COD",
            };
            createNewOrder(orderData);
        }

        if (method === "Card") {
            alert("Card Payment Coming Soon!");
        }

        if (method === "JazzCash") {
            if (!jazzcashScreenshot) {
                return toast.error("Please upload JazzCash transaction screenshot");
            }
            const orderData = {
                shippingInfo,
                orderItems: cartItems,
                itemsPrice,
                shippingAmount: shippingPrice,
                taxAmount: taxPrice,
                totalAmount: totalPrice,
                paymentInfo: {
                    status: "not_paid",
                    screenshot: jazzcashScreenshot,
                },
                paymentMethod: "JazzCash",
            };
            createNewOrder(orderData);
        }
    };

    return (
        <>
            <MetaData title="Payment Method" />
            <CheckoutSteps shipping confirmOrder payment />

            {/* Same layout as Shipping.js */}
            <div
                className="container d-flex align-items-center justify-content-center p-4 w-100"
                style={{ minHeight: "55vh", paddingTop: "1px", paddingBottom: "100px" }}
            >
                <div className="row justify-content-center w-100">
                    <div className="col-12 col-md-8 col-lg-6">
                        <div className="card shadow-sm rounded-4 border-0 p-4">
                            <h2 className="fw-bold text-center mb-4" style={{ color: "#5a2d82" }}>Select Payment Method</h2>

                            <form onSubmit={submitHandler}>
                                {/* COD */}
                                <div className="form-check mb-3">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="payment_mode"
                                        id="codradio"
                                        value="COD"
                                        onChange={(e) => setMethod("COD")}
                                        required
                                    />
                                    <label className="form-check-label" htmlFor="codradio">
                                        Cash on Delivery
                                    </label>
                                </div>

                                {/* JazzCash */}
                                <div className="form-check mb-3">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="payment_mode"
                                        id="jazzcashradio"
                                        value="JazzCash"
                                        onChange={(e) => setMethod("JazzCash")}
                                        required
                                    />
                                    <label className="form-check-label" htmlFor="jazzcashradio">
                                        JazzCash - Bank Transfer
                                    </label>
                                </div>

                                {method === "JazzCash" && (
                                    <div className="alert shadow-sm rounded-4 p-4" style={{ background: "#feeeffff" }}>
                                        <h5 className="fw-bold mb-3" style={{ color: "#5a2d82" }}>Jazzcash Payment Details</h5>
                                        <p className="mb-2" style={{ color: "#5a2d82" }}>Please send the total amount to our Jazzcash account:</p>
                                        <ul className="mb-3">
                                            <li><b style={{ color: "#5a2d82" }}>Account Name:</b> Maham Rizwan</li>
                                            <li><b style={{ color: "#5a2d82" }}>Jazzcash Number:</b> 0321-2413134</li>
                                        </ul>
                                        <p className="mb-3" style={{ color: "#5a2d82" }}>After making the payment, please upload a screenshot as proof of payment.</p>
                                        <div className="mb-3">
                                            <label className="form-label fw-semibold" style={{ color: "#5a2d82" }}>Upload Jazzcash Transaction Screenshot*</label>
                                            <input
                                                type="file"
                                                accept="image/*"
                                                className="form-control"
                                                onChange={(e) => {
                                                    const file = e.target.files?.[0];
                                                    if (!file) return;
                                                    setJazzcashFileName(file.name);
                                                    const reader = new FileReader();
                                                    reader.onloadend = () => {
                                                        setJazzcashScreenshot(String(reader.result));
                                                    };
                                                    reader.readAsDataURL(file);
                                                }}
                                            />
                                            {jazzcashFileName ? (
                                                <small className="text-muted">Selected: {jazzcashFileName}</small>
                                            ) : (
                                                <small className="text-muted">Accepted formats: JPG, PNG</small>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {/* Submit */}
                                <div className="d-grid">
                                    <button
                                        id="shipping_btn"
                                        type="submit"
                                        className="btn View-btn py-2 fw-semibold"
                                        disabled={isLoading}
                                    >
                                        {isLoading ? "Processing..." : "CONTINUE"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PaymentMethod;